import type { InstrumentId, SoundKey } from "./types";

/**
 * Sample manifest per instrument — single source of truth shared
 * by both backends: the web requests them over HTTP from `audio/{id}/{key}.ogg`
 * (relative to the app base) and native embeds them from
 * `apps/web/public/audio` at compile time with the same path convention.
 */

/** Full octaves 4 and 5: 24 semitones, enough for the nursery songs. */
const PIANO_KEYS = [
  "C4",
  "Db4",
  "D4",
  "Eb4",
  "E4",
  "F4",
  "Gb4",
  "G4",
  "Ab4",
  "A4",
  "Bb4",
  "B4",
  "C5",
  "Db5",
  "D5",
  "Eb5",
  "E5",
  "F5",
  "Gb5",
  "G5",
  "Ab5",
  "A5",
  "Bb5",
  "B5",
] as const;

/** C major diatonic scale + high C: 13 rainbow bars (M2). */
const XYLOPHONE_KEYS = [
  "C4",
  "D4",
  "E4",
  "F4",
  "G4",
  "A4",
  "B4",
  "C5",
  "D5",
  "E5",
  "F5",
  "G5",
  "A5",
] as const;

/** Kids' kit of 6 pads (see scripts/audio/fetch-samples.sh for the GM sources). */
const DRUM_KEYS = ["kick", "snare", "tom", "woodblock", "cowbell", "steel"] as const;

export const SAMPLE_MANIFEST: Record<InstrumentId, readonly SoundKey[]> = {
  piano: PIANO_KEYS,
  xylophone: XYLOPHONE_KEYS,
  drums: DRUM_KEYS,
};

/** Sample path relative to the app's public root (no leading /). */
export function sampleUrl(instrument: InstrumentId, key: SoundKey): string {
  return `audio/${instrument}/${key}.ogg`;
}
